import React from 'react';
import ReactDOM from 'react-dom';
import * as generalUtils from '@puls/puls-general-utils';
//import registerServiceWorker from './registerServiceWorker';
import { unregister as unregisterServiceWorker } from './registerServiceWorker'
import config from './config.js';
import ExternalDataStore from './managers/ExternalDataStore.js';
import superSubscriberMockData from './Constants/mocks/super-subscriber-data.js';
import pmCompanyMockData from './Constants/mocks/pm-company-data.js';
import { handlePmSessionRedirect } from './Services/pm-company.js';

try {
	var paramsJson = {};

	new URLSearchParams(window.location.search).forEach(function (value, key) {
  		paramsJson[key] = value;
	});
	window.__initial_query_parameters__ = paramsJson;
} catch (error) {
	
}

const flowSessionKey = 'app_flow';

function renderApp(App, props = {}){
    ReactDOM.render(<App {...props}/>, document.getElementById('root'));
}

try {
    generalUtils.rum.start(null)
} catch (error) {
    
}

injectFonts();
handleQuery();
setSuperServerData();
getServerData();
handleSessionRedirects();

//registerServiceWorker();
unregisterServiceWorker();

const isSuperFlow = isSuperAppFlow();

if(isSuperFlow) {
    setTimeout(() => {
        sessionStorage.setItem(flowSessionKey, 'super');
    }, 500)
}
if(window.location.href.indexOf('/create-sale/') !== -1){
    import('./App/CreateSale.js').then(comp => {
        renderApp(comp.default)
    })
} else if(window.location.href.indexOf('/create-order') !== -1) {
    import('./App/CreateAppointment2.js').then(comp => {
        renderApp(comp.default)
    })
} else if(window.location.href.indexOf('/ranking') !== -1) {
    import('./App/Ranking.js').then(comp => {
        renderApp(comp.default)
    })
} else if (window.location.href.indexOf('/confirm-appointment') !== -1) {
    import('./App/ConfirmAppointment.js').then(comp => {
        renderApp(comp.default)
    })
} else {
	try {
		// for hubspot usage
		window.__puls_funnel_initial_entry_point = window.location.href;
	} catch (error) {
		
	}
    import('./App/CreateAppointment.js').then(comp => {
        renderApp(comp.default, { isSuperFlow })
    })
}

function handleQuery(){
    var { search } = window.location;
    if(!search) return;

    if (search[0] === '?') {
        search = search.substring(1)
    }

    var searchParams = new URLSearchParams(search);
    var searchObject = {
        funnel_entry_link : window.location.href
    }

    var utms = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_term', 'utm_content', 'ad_id'];
    var clicks = ['gclid', 'fbclid', 'msclid'];
    utms.forEach(element => {
        var value = searchParams.get(element);
        if(value) searchObject[element] = value;
    });

    clicks.forEach(element => {
        var value = searchParams.get(element);
        if(value) searchObject['click_id'] = value;
    });

    window.__entry_query_parameters__ = searchObject;
    if(window.sessionStorage) window.sessionStorage.setItem('__entry_query_parameters__', JSON.stringify(searchObject))
}

function injectFonts() {
    if(!config.client_dev_mode) return null;
    var linkTag = document.createElement('link');
    linkTag.rel = 'stylesheet';
    linkTag.type = 'text/css';
    const isSuper = isSuperAppFlow();
    const withSuperMember = new URLSearchParams(window.location.search).has('ssbnid');
    linkTag.href = isSuper && !withSuperMember ? '/css-fonts/super-fonts.css' : '/css-fonts/default-fonts.css';
    document.head.appendChild(linkTag);
}

function isSuperAppFlow() {
    return new URLSearchParams(window.location.search).get('origin') === 'super' || sessionStorage.getItem(flowSessionKey) === 'super' || window.location.hostname.indexOf('hellosuper') !== -1;
}

function setSuperServerData() {
    let subscriberServerData;
    if(config.client_dev_mode) {
        if(new URLSearchParams(window.location.search).has('ssbnid')) subscriberServerData = superSubscriberMockData;
    } else {
        subscriberServerData = generalUtils.funnelsUtilsServices.getInjectedServerData('super-subscriber-data');
    }
    
    if(subscriberServerData) {
        ExternalDataStore.setData('super', subscriberServerData);
    }
}

function getServerData() {
    let serverData = [];
    const serverDataList = [
        {
            mock: {
                query: 'pm_company',
                data :pmCompanyMockData
            },
            serverInjectionKey: 'pm-company-data',
            contextKey: 'pm-company'
        }
    ];
    serverDataList.forEach((item) => {
        let data;
        if(config.client_dev_mode) {
            if(new URLSearchParams(window.location.search).has(item.mock.query)) data = item.mock.data;
        } else {
            data = generalUtils.funnelsUtilsServices.getInjectedServerData(item.serverInjectionKey);
        }
        if(data) serverData.push({
            context: item.contextKey,
            data
        });
    })
    serverData.forEach((sd) => {
        ExternalDataStore.setData(sd.context, sd.data);
    })
}

function handleSessionRedirects() {
    const handlers = [
        handlePmSessionRedirect
    ]
    for(const handler of handlers) {
        // If handler executes redirect, stop processing
        if(handler()) {
            return;
        }
    }
}